import React from 'react';
import { ConfigService } from '../../services';
import { CloseButtonSvgIcon } from '../icons/IconProvider';
import CopyToClipboardText from '../CopyToClipboardText';

const KycLinkModal = ({ isOpen, onClose, kycLink, expiry }) => {
  if (!isOpen) return null;

  const expired = !expiry || new Date() > new Date(expiry);

  return (
    <>
      <div className="justify-center flex items-center fixed inset-0 z-50">
        <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-lg relative">
          <button
            className="absolute right-3 top-3 text-gray-500"
            onClick={onClose}
          >
            <CloseButtonSvgIcon />
          </button>
          <h3 className="text-lg font-semibold mb-4">KYC Direct Link</h3>
          {kycLink ? (
            <div className="mb-4">
              <div className="flex items-center gap-2">
                <input
                  type="text"
                  value={kycLink}
                  readOnly
                  className="w-full border p-2 rounded text-sm bg-gray-100"
                />
                <CopyToClipboardText
                  text={kycLink}
                  copyMessage="KYC link copied!"
                />
              </div>
              <p className="text-sm text-gray-600 mt-2">
                Expiry:{' '}
                {expiry
                  ? ConfigService.dateFormat(expiry, true)
                  : 'No expiry provided'}
                {expired && (
                  <span className="text-brandRed ml-2 font-semibold">
                    (Expired)
                  </span>
                )}
              </p>
            </div>
          ) : (
            <p className="text-sm text-red-600">
              Failed to load KYC link. Please try regenerating.
            </p>
          )}
          <div className="flex justify-end gap-3 mt-4">
            <button
              onClick={onClose}
              className="bg-gray-400 text-white px-4 py-2 rounded-md"
            >
              Close
            </button>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
};

export default KycLinkModal;
